import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1319Component } from './kymw1319.component';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { GetFeatureThemaListForUpdateService } from './api-services/get-feature-thema-list-for-update.service';
import { GetSelectedPlanGoodsFeatureListService } from './api-services/get-selected-plan-goods-feature-list.service';
import { UpdatePlanGoodsFeatureService } from './api-services/update-plan-goods-feature.service';
import { GetBundleCatalogInfoForFeatureService } from './api-services/get-bundle-catalog-info-for-feature.service';

/**
 * 特集付替設定画面 モジュール設定クラス
 *
 * @export KYMW1319Module
 * @class KYMW1319Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
  ],
  declarations: [
    KYMW1319Component
  ],
  providers: [
    GetFeatureThemaListForUpdateService,
    GetSelectedPlanGoodsFeatureListService,
    UpdatePlanGoodsFeatureService,
    GetBundleCatalogInfoForFeatureService,
  ]
})
export class KYMW1319Module {
}
